import React, { useEffect, useRef, useState } from "react";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";

import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import { ReactComponent as DownArrow } from "../../../../../assets/settingPage/arrow-down.svg";
import useLocales from "../../../../../hooks/useLocales";

import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";
import { I18nextProvider } from "react-i18next";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";
import { useSelector } from "react-redux";

// This Form component is responsible for add and edit Divider Block

const DividerForm = ({
  formType,
  submitHandlerParent,
  handleDelete,
  isLoading,
  preHeaderData,
  handleDividerUpdate,
}) => {
  const { allLangs, tComponent, handleLanguageChange } = useLocales();
  const { darkMode } = useSelector((state) => state.theme);

  const { setActiveMainPageNav } = useStateContext();

  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  const colorDropDownRef = useRef();
  const colorDropDownBtnRef = useRef();

  const [pickedColor, setPickedColor] = useColor("#CAFF");

  useEffect(() => {
    setColorHandler(pickedColor);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickedColor]);

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang]);

  const [color, setColor] = useState("#CAFF");
  const [openColopicker, setOpenColopicker] = useState(false);

  const setColorHandler = (color) => {
    setColor(color.hex);
  };
  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // color dropdown outside click handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openColopicker &&
        colorDropDownRef.current &&
        !colorDropDownRef.current.contains(e.target) &&
        !colorDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenColopicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openColopicker]);

  const handleDividerSubmit = async () => {
    const language = selectedLang;
    submitHandlerParent(color, language);
  };

  const handleDividerUpdateColor = async () => {
    const language = selectedLang;
    handleDividerUpdate(color, language);
  };

  useEffect(() => {
    const headerValue = preHeaderData?.data?.coloum_value;
    if (preHeaderData) {
      setColor(JSON.parse(headerValue)?.coloum_value?.color);
      setSelectedLang(preHeaderData?.data?.language);
      const matchedLang = allLangs?.find(
        (lang) => lang.value === preHeaderData?.data?.language
      );
      const shouldSetLang = matchedLang?.label;
      setSelectedReporterType(shouldSetLang);
      handleLanguageChange(preHeaderData?.data?.language);
    }
  }, [preHeaderData]);

  const deleteHandler = async (data) => {
    if (formType === "add") {
      setColor("#CAFF");
    } else {
      handleDelete(data);
    }
  };

  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };

  return (
    <I18nextProvider i18n={i18nForComponent}>
      <>
        <div
          className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <div className="border rounded-[10px] bg-light_bg_v5 dark:bg-dark-secondary p-[25px] dark:border-color_dark">
            <div className="flex justify-between items-center mb-[20px] sm:mb-[25px]">
              <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
                {formType === "edit" && tComponent(`divider.${formType}`)}
                {formType === "add" && tComponent(`divider.${formType}`)}
                &nbsp;
                {tComponent("divider.divider_cap")}
              </p>
              {formType === "add" && (
                <div className="flex items-center justify-center">
                  <div className="relative w-[115px] sm:w-[145px]">
                    <div
                      onClick={() => {
                        setSelectReporterTypeDropDown(
                          !selectReporterTypeDropDown
                        );
                      }}
                      className={`bg-light_bg_v4 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                    >
                      {selectedReporterType
                        ? selectedReporterType
                        : tComponent("divider.select_lang")}
                      <DownArrow />
                    </div>
                    {selectReporterTypeDropDown && (
                      <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                        {allLangs?.map((item, i) => {
                          return (
                            <div
                              key={i}
                              onClick={() => {
                                setSelectedLang(item.value); // Set selected language code
                                setSelectedReporterType(item?.label);
                                setSelectReporterTypeDropDown(false);
                                handleChangeLang(item?.value);
                              }}
                              className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                            >
                              {item.label}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {formType === "edit" && (
                <div
                  className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
                >
                  {selectedReporterType ? selectedReporterType : "English"}
                </div>
              )}
            </div>
            <div>
              <div className="relative flex items-center justify-start gap-[19px] w-full mb-[24px] sm:mb-[25px]">
                <div
                  ref={colorDropDownBtnRef}
                  onClick={() => setOpenColopicker(!openColopicker)}
                  style={{
                    background: color,
                  }}
                  className={`rounded-lg cursor-pointer w-12 h-12 border`}
                ></div>
                {openColopicker && (
                  <div
                    className="absolute top-0 lg:w-[80%] 2xl:w-[60%] w-full pb-5 "
                    style={{ zIndex: "999999999" }}
                  >
                    <div
                      ref={colorDropDownRef}
                      className="border bg-white  shadow-xl rounded-lg p-3"
                    >
                      <ColorPicker
                        color={pickedColor}
                        onChange={setPickedColor}
                        hideInput={true}
                        height={150}
                      />
                      <div className="flex flex-wrap xl:flex-nowrap justify-center items-center -mt-[8px] gap-2 px-2">
                        <div className="flex justify-center items-center gap-1 w-full">
                          <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                            <p>HEX</p>
                          </div>
                          <p>:</p>
                          <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                            <p>{pickedColor.hex}</p>
                          </div>
                        </div>
                        <div className="flex gap-1 justify-between w-full ">
                          <div className="border rounded-md px-1 py-0.5 text-small1">
                            {Math.round((pickedColor.rgb.a / 1) * 100)}%
                          </div>
                          <button
                            className="rounded-full px-3 text-small2_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                            onClick={() => setOpenColopicker(false)}
                          >
                            DONE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div>
                  <div className="text-small2 text-body_copy_medium_color dark:text-color_v1_dark">
                    {tComponent("divider.color")}
                  </div>
                  <div className="text-small2_b text-heading_color dark:text-color_v1_dark ">
                    <input
                      value={color}
                      type="text"
                      className="focus:outline-none bg-transparent -mt-[8px]"
                      onChange={(e) => {
                        setPickedColor((color) => {
                          return { ...color, hex: e.target.value };
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            {(formType === "add" && (
              <button
                type="button"
                onClick={handleDividerSubmit}
                className={`cursor-pointer text-center w-full rounded-full p-[6px] px-4 bg-main_color text-light_bg_v5 text-small3_b ${
                  isLoading ? "opacity-70" : ""
                }`}
                disabled={isLoading}
              >
                {isLoading ? (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-3 h-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                ) : (
                  tComponent("divider.add_divider")
                )}
              </button>
            )) || (
              <div className="flex mt-[26px] items-center justify-end">
                <button
                  type="button"
                  onClick={() => deleteHandler()}
                  className="flex justify-center items-center"
                >
                  {darkMode ? <TrashIconDark /> : <TrashIcon />}
                  <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                    {tComponent("divider.delete_cap")}
                  </p>
                </button>
                <ExtraSmallFilledButton
                  name={`${tComponent("divider.save_cap")}`}
                  buttonType={"submit"}
                  isLoading={isLoading}
                  onClickHandler={
                    (formType === "edit" && handleDividerUpdateColor) ||
                    handleDividerSubmit
                  }
                  classes={"ms-3"}
                />
              </div>
            )}
          </div>
        </div>
      </>
    </I18nextProvider>
  );
};

export default DividerForm;
